module.exports = __webpack_public_path__ + "static/media/bottom.4d2a5693.svg";